import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avatarInitials',
  standalone: true,
})
export class AvatarInitialsPipe implements PipeTransform {
  public transform(username: string | null | undefined): string {
    const words = (username || '').trim().split(/\s+/);

    // Return an empty string if username is empty or has only whitespace characters
    return words.length === 0 ? '' : this.getInitials(words);
  }

  private getInitials(words: string[]): string {
    if (words.length >= 2) {
      // Use the first and second words to create initials
      const firstInitial = words[0][0].toUpperCase();
      const secondInitial = words[1][0].toUpperCase();
      return `${firstInitial}${secondInitial}`;
    }

    // Use the first and last characters of the word to create initials
    const firstInitial = words[0][0].toUpperCase();
    const lastInitial = words[0][words[0].length - 1].toUpperCase();
    return `${firstInitial}${lastInitial}`;
  }
}
